import { render, staticRenderFns } from "./UILoader.vue?vue&type=template&id=2f85ae84"
var script = {}
import style0 from "./UILoader.vue?vue&type=style&index=0&id=2f85ae84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports